import { Routes } from "@angular/router";
import { matchGiftBoxV2, requireRoleAdmin } from "./guards/auth.guard";

export const appRoutes: Routes = [
  {
    path: "InvitationLoginPage",
    loadComponent: () =>
      import("./pages/invitation-login/invitation-login").then(
        (m) => m.InvitationLoginPage
      ),
  },
  {
    path: "OnboardingForCastPage",
    loadComponent: () =>
      import(
        "./pages/onboarding/onboarding-for-cast/onboarding-for-cast.page"
      ).then((m) => m.OnboardingForCastPage),
  },
  {
    path: "OnboardingPage",
    loadComponent: () =>
      import("./pages/onboarding/onboarding-for-guest/onboarding.page").then(
        (m) => m.OnboardingPage
      ),
  },
  {
    path: "NoLoginUserProfilePage",
    loadComponent: () =>
      import(
        "./pages/onboarding/onboarding-for-guest/no-login-user-profile/no-login-user-profile.page"
      ).then((m) => m.NoLoginUserProfilePage),
  },
  {
    path: "NoLoginSearchPage",
    loadComponent: () =>
      import(
        "./pages/onboarding/onboarding-for-guest/no-login-search/no-login-search.page"
      ).then((m) => m.NoLoginSearchPage),
  },
  {
    path: "RequestPhoneAuthPage",
    loadComponent: () =>
      import(
        "./pages/onboarding/onboarding-for-guest/phone-auth/request-phone-auth/request-phone-auth.page"
      ).then((m) => m.RequestPhoneAuthPage),
  },
  {
    path: "VerifyPhoneAuthPage",
    loadComponent: () =>
      import(
        "./pages/onboarding/onboarding-for-guest/phone-auth/verify-phone-auth/verify-phone-auth.page"
      ).then((m) => m.VerifyPhoneAuthPage),
  },
  {
    path: "SuccessPhoneAuthPage",
    loadComponent: () =>
      import(
        "./pages/onboarding/onboarding-for-guest/phone-auth/success-phone-auth/success-phone-auth.page"
      ).then((m) => m.SuccessPhoneAuthPage),
  },
  {
    path: "",
    redirectTo: "OnboardingPage",
    pathMatch: "full",
  },
  {
    path: "RequestMailAuthPage",
    loadComponent: () =>
      import(
        "./pages/onboarding/onboarding-for-guest/mail-auth/request-mail-auth.page"
      ).then((m) => m.RequestMailAuthPage),
  },
  {
    path: "TabsPage",
    loadChildren: () =>
      import("./pages/tabs/tabs.router").then((m) => m.tabsRoutes),
    data: { preload: true },
  },
  {
    path: "SearchTabPage",
    loadComponent: () =>
      import("./pages/search-tab/search-tab.page").then((m) => m.SearchTabPage),
  },
  {
    path: "ChatPage/:timestamp",
    loadComponent: () => import("./pages/chat/chat").then((m) => m.ChatPage),
  },
  {
    path: "ApplyAppointmentPage",
    loadComponent: () =>
      import("./pages/apply-appointment/apply-appointment").then(
        (m) => m.ApplyAppointmentPage
      ),
  },
  {
    path: "RankingPage",
    loadComponent: () =>
      import("./pages/ranking/ranking.page").then((m) => m.RankingPage),
  },
  {
    path: "RankingListPage",
    loadComponent: () =>
      import("./pages/ranking-list/ranking-list.page").then(
        (m) => m.RankingListPage
      ),
  },
  {
    path: "HistoricalRankingPage",
    loadComponent: () =>
      import("./pages/historical-ranking/historical-ranking.page").then(
        (m) => m.HistoricalRankingPage
      ),
  },
  {
    path: "BestRecordRankingPage",
    loadComponent: () =>
      import("./pages/best-record-ranking/best-record-ranking.page").then(
        (m) => m.BestRecordRankingPage
      ),
  },
  {
    path: "BoostPassPurchasePage",
    loadComponent: () =>
      import("./pages/boost-pass-purchase/boost-pass-purchase.page").then(
        (m) => m.BoostPassPurchasePage
      ),
  },
  {
    path: "BoostPassConfirmPage",
    loadComponent: () =>
      import(
        "./pages/boost-pass-purchase/boost-pass-confirm/boost-pass-confirm.page"
      ).then((m) => m.BoostPassConfirmPage),
  },
  {
    path: "BoostPassCompletePage",
    loadComponent: () =>
      import(
        "./pages/boost-pass-purchase/boost-pass-complete/boost-pass-complete.page"
      ).then((m) => m.BoostPassCompletePage),
  },
  {
    path: "BoostPassManagementPage",
    loadComponent: () =>
      import("./pages/boost-pass-management/boost-pass-management.page").then(
        (m) => m.BoostPassManagementPage
      ),
  },
  {
    path: "BoostPassCancelPage",
    loadComponent: () =>
      import("./pages/boost-pass-cancel/boost-pass-cancel.page").then(
        (m) => m.BoostPassCancelPage
      ),
  },
  {
    path: "ThanksMessagePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/thanks-message/thanks-message").then(
            (m) => m.ThanksMessagePage
          ),
      },
    ],
  },
  {
    path: "AdminPage",
    loadComponent: () =>
      import("./pages/maintenance/admin/admin.page").then((m) => m.AdminPage),
    canActivate: [requireRoleAdmin()],
  },
  {
    path: "FpRankingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/fp/fp-ranking/fp-ranking.page").then(
            (m) => m.FpRankingPage
          ),
      },
    ],
  },
  {
    path: "FpMultiplierProgramPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/fp/fp-multiplier-program/fp-multiplier-program.page"
          ).then((m) => m.FpMultiplierProgramPage),
      },
    ],
  },
  // 旧FPの説明(WhatFpPage)は 2026/10 の新FPで廃止。古い導線・お知らせのリンクは新FPのキャストグレード詳細へ
  {
    path: "WhatFpPage",
    redirectTo: "CastGradeV2Page",
    pathMatch: "full",
  },
  {
    path: "CastPerformanceSummaryPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/mypage-cast/cast-performance-summary/cast-performance-summary.page"
          ).then((m) => m.CastPerformanceSummaryPage),
      },
    ],
  },
  {
    path: "HelpPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/help/help").then((m) => m.HelpPage),
      },
    ],
  },
  {
    path: "OtherMenuPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/help/other-menu/other-menu.page").then(
            (m) => m.OtherMenuPage
          ),
      },
    ],
  },
  {
    path: "WithdrawalSurveyPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/help/withdrawal-survey/withdrawal-survey.page"
          ).then((m) => m.WithdrawalSurveyPage),
      },
    ],
  },
  {
    path: "HotlinePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/help/hotline/hotline").then(
            (m) => m.HotlinePage
          ),
      },
    ],
  },
  {
    path: "EditProfilePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/edit-profile/edit-profile").then(
            (m) => m.EditProfilePage
          ),
      },
    ],
  },
  {
    path: "EditNicknamePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-nickname/edit-nickname"
          ).then((m) => m.EditNicknamePage),
      },
    ],
  },
  {
    path: "EditOneWordPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-one-word/edit-one-word"
          ).then((m) => m.EditOneWordPage),
      },
    ],
  },
  {
    path: "EditPricePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/edit-profile/edit-price/edit-price").then(
            (m) => m.EditPricePage
          ),
      },
    ],
  },
  {
    path: "EditGolfSettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-golf-setting/edit-golf-setting"
          ).then((m) => m.EditGolfSettingPage),
      },
    ],
  },
  {
    path: "EditGolfPricePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-golf-setting/edit-golf-price/edit-golf-price"
          ).then((m) => m.EditGolfPricePage),
      },
    ],
  },
  {
    path: "EditGolfSelectPickupAreaPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-golf-setting/edit-golf-select-pickup-area/edit-golf-select-pickup-area"
          ).then((m) => m.EditGolfSelectPickupAreaPage),
      },
    ],
  },
  {
    path: "EditGolfSelectAverageScorePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-golf-setting/edit-golf-select-average-score/edit-golf-select-average-score"
          ).then((m) => m.EditGolfSelectAverageScorePage),
      },
    ],
  },
  {
    path: "EditOnlinePricePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-online-price/edit-online-price"
          ).then((m) => m.EditOnlinePricePage),
      },
    ],
  },
  {
    path: "EditAutoMessagePhrasePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-auto-message-phrase/edit-auto-message-phrase"
          ).then((m) => m.EditAutoMessagePhrasePage),
      },
    ],
  },
  {
    path: "EditAutoMessageTextPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-auto-message-text/edit-auto-message-text"
          ).then((m) => m.EditAutoMessageTextPage),
      },
    ],
  },
  {
    path: "EditAutoReturnMessagePhrasePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-auto-return-message-phrase/edit-auto-return-message-phrase"
          ).then((m) => m.EditAutoReturnMessagePhrasePage),
      },
    ],
  },
  {
    path: "EditAutoReturnMessageTextPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-auto-return-message-text/edit-auto-return-message-text"
          ).then((m) => m.EditAutoReturnMessageTextPage),
      },
    ],
  },
  {
    path: "EditFixedMessagePhrasePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-fixed-message-phrase/edit-fixed-message-phrase"
          ).then((m) => m.EditFixedMessagePhrasePage),
      },
    ],
  },
  {
    path: "EditPerformanceCategoryPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-performance-category/edit-performance-category"
          ).then((m) => m.EditPerformanceCategoryPage),
      },
    ],
  },
  {
    path: "EditSelfIntroductionPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-self-introduction/edit-self-introduction"
          ).then((m) => m.EditSelfIntroductionPage),
      },
    ],
  },
  {
    path: "EditBasicInformationPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-basic-information/edit-basic-information"
          ).then((m) => m.EditBasicInformationPage),
      },
    ],
  },
  {
    path: "EditEasyProfilePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/edit-profile/edit-easy-profile/edit-easy-profile"
          ).then((m) => m.EditEasyProfilePage),
      },
    ],
  },
  {
    path: "SettingPage",
    loadComponent: () =>
      import("./pages/mypage/setting/setting.page").then((m) => m.SettingPage),
  },
  {
    path: "AccountSettingPage",
    loadComponent: () =>
      import(
        "./pages/mypage/setting/account-setting/account-setting.page"
      ).then((m) => m.AccountSettingPage),
  },
  {
    path: "AppIconSettingPage",
    loadComponent: () =>
      import(
        "./pages/mypage/setting/app-icon-setting/app-icon-setting.page"
      ).then((m) => m.AppIconSettingPage),
  },
  {
    path: "PushNoticeSettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/setting/push-notice-setting/push-notice-setting"
          ).then((m) => m.PushNoticeSettingPage),
      },
    ],
  },
  {
    path: "PushPrivateSettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/setting/push-private-setting/push-private-setting.page"
          ).then((m) => m.PushPrivateSettingPage),
      },
    ],
  },
  {
    path: "RankingDisplaySettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/setting/ranking-display-setting/ranking-display-setting.page"
          ).then((m) => m.RankingDisplaySettingPage),
      },
    ],
  },
  {
    path: "PushEvaluationBadgeSettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/setting/push-evaluation-badge-setting/push-evaluation-badge-setting"
          ).then((m) => m.PushEvaluationBadgeSettingPage),
      },
    ],
  },
  {
    path: "PushTimelineSettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/setting/push-timeline-setting/push-timeline-setting"
          ).then((m) => m.PushTimelineSettingPage),
      },
    ],
  },
  {
    path: "PushOnlineStatusSettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/setting/push-online-setting/push-online-status-setting"
          ).then((m) => m.PushOnlineStatusSettingPage),
      },
    ],
  },
  {
    path: "EmailSettingPage",
    loadComponent: () =>
      import(
        "./pages/mypage/setting/account-setting/email-setting/email-setting.page"
      ).then((m) => m.EmailSettingPage),
  },
  {
    path: "PhoneNumberSettingPage",
    loadComponent: () =>
      import(
        "./pages/mypage/setting/account-setting/phone-number-setting/phone-number-setting.page"
      ).then((m) => m.PhoneNumberSettingPage),
  },
  {
    path: "UpdatePhoneNumberPage",
    loadComponent: () =>
      import(
        "./pages/mypage/setting/account-setting/update-phone-number/update-phone-number.page"
      ).then((m) => m.UpdatePhoneNumberPage),
  },
  {
    path: "AccountSwitchPage",
    loadComponent: () =>
      import("./pages/mypage/setting/account-switch/account-switch.page").then(
        (m) => m.AccountSwitchPage
      ),
  },
  {
    path: "PushLinkSettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/setting/push-link-setting/push-link-setting"
          ).then((m) => m.PushLinkSettingPage),
      },
    ],
  },
  {
    path: "PushPatoCallSettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/setting/push-pato-call-setting/push-pato-call-setting"
          ).then((m) => m.PushPatoCallSettingPage),
      },
    ],
  },
  {
    path: "NoticePage",
    loadComponent: () =>
      import("./pages/mypage/notice/notice.page").then((m) => m.NoticePage),
    data: { preload: true },
  },
  {
    path: "FriendCastPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/friend-cast/friend-cast").then(
            (m) => m.FriendCastPage
          ),
      },
    ],
  },
  {
    path: "InviteUserPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/invite-user/invite-user").then(
            (m) => m.InviteUserPage
          ),
      },
    ],
  },
  {
    path: "CastGradeV2Page",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/mypage-cast/cast-grade-v2/cast-grade-v2").then(
            (m) => m.CastGradeV2Page
          ),
      },
    ],
  },
  // 旧グレード詳細(CastGradeDetailV2Page)は 2026/10 の新FPで廃止。古い導線・お知らせのリンクは新FPのキャストグレード詳細へ
  {
    path: "CastGradeDetailV2Page",
    redirectTo: "CastGradeV2Page",
    pathMatch: "full",
  },
  {
    path: "GuestGradePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/guest-grade/guest-grade.page").then(
            (m) => m.GuestGradePage
          ),
      },
    ],
  },
  {
    path: "GuestGradeDetailPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/guest-grade/guest-grade-detail/guest-grade-detail"
          ).then((m) => m.GuestGradeDetailPage),
      },
    ],
  },
  {
    path: "MetCastHistoryPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/met-cast-history/met-cast-history").then(
            (m) => m.MetCastHistoryPage
          ),
      },
    ],
  },
  {
    path: "FriendCommunityPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/mypage-guest/friend-community/friend-community"
          ).then((m) => m.FriendCommunityPage),
      },
    ],
  },
  {
    path: "FriendRegistrationV2Page",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/mypage-guest/friend-community/friend-registration-v2/friend-registration-v2"
          ).then((m) => m.FriendRegistrationV2Page),
      },
    ],
  },
  {
    path: "FriendRegistrationByIdPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/mypage-guest/friend-community/friend-registration-by-id/friend-registration-by-id"
          ).then((m) => m.FriendRegistrationByIdPage),
      },
    ],
  },
  {
    path: "FriendRegistrationByIdV2Page",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/mypage-guest/friend-community/friend-registration-by-id-v2/friend-registration-by-id-v2"
          ).then((m) => m.FriendRegistrationByIdV2Page),
      },
    ],
  },
  {
    path: "CastFalledPage",
    loadComponent: () =>
      import("./pages/cast-applied/cast-falled/cast-falled.page").then(
        (m) => m.CastFalledPage
      ),
  },
  {
    path: "FriendTimelineSettingPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/mypage-guest/friend-community/friend-timeline-setting/friend-timeline-setting"
          ).then((m) => m.FriendTimelineSettingPage),
      },
    ],
  },
  {
    path: "PurchaseHistoryPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/purchase-history/purchase-history").then(
            (m) => m.PurchaseHistoryPage
          ),
      },
    ],
  },
  {
    path: "BoostPassHistoryPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/boost-pass-history/boost-pass-history").then(
            (m) => m.BoostPassHistoryPage
          ),
      },
    ],
  },
  {
    path: "BoostPassHistoryDetailPage",
    loadComponent: () =>
      import(
        "./pages/mypage/boost-pass-history/boost-pass-history-detail/boost-pass-history-detail.page"
      ).then((m) => m.BoostPassHistoryDetailPage),
  },
  {
    path: "PurchaseHistoryDetailPage",
    loadComponent: () =>
      import(
        "./pages/mypage/purchase-history/purchase-history-detail/purchase-history-detail.page"
      ).then((m) => m.PurchaseHistoryDetailPage),
  },
  {
    path: "AppointmentDetailPage",
    loadComponent: () =>
      import("./pages/appointment-detail/appointment-detail").then(
        (m) => m.AppointmentDetailPage
      ),
  },
  {
    path: "CreditCardsPage",
    loadComponent: () =>
      import("./pages/mypage/credit-cards/credit-cards.page").then(
        (m) => m.CreditCardsPage
      ),
  },
  {
    path: "PurchasePointPage",
    loadComponent: () =>
      import("./pages/mypage/purchase-point/purchase-point.page").then(
        (m) => m.PurchasePointPage
      ),
  },
  {
    path: "BankTransferPage",
    loadComponent: () =>
      import(
        "./pages/mypage/purchase-point/bank-transfer/bank-transfer.page"
      ).then((m) => m.BankTransferPage),
  },
  {
    path: "CouponManagePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/coupon-manage/coupon-manage").then(
            (m) => m.CouponManagePage
          ),
      },
    ],
  },
  // クーポンギフト(デジタルギフトカード): 券種一覧 → 購入 → 完了 / 購入済み一覧
  {
    path: "DigitalGiftProductsPage",
    loadComponent: () =>
      import(
        "./pages/digital-gift/digital-gift-products/digital-gift-products.page"
      ).then((m) => m.DigitalGiftProductsPage),
  },
  {
    path: "DigitalGiftPurchasePage",
    loadComponent: () =>
      import(
        "./pages/digital-gift/digital-gift-purchase/digital-gift-purchase.page"
      ).then((m) => m.DigitalGiftPurchasePage),
  },
  {
    path: "DigitalGiftCompletePage",
    loadComponent: () =>
      import(
        "./pages/digital-gift/digital-gift-complete/digital-gift-complete.page"
      ).then((m) => m.DigitalGiftCompletePage),
  },
  {
    path: "PurchasedDigitalGiftsPage",
    loadComponent: () =>
      import(
        "./pages/digital-gift/purchased-digital-gifts/purchased-digital-gifts.page"
      ).then((m) => m.PurchasedDigitalGiftsPage),
  },
  {
    path: "SalesPointMenuPage",
    loadComponent: () =>
      import("./pages/mypage/sales-point-menu/sales-point-menu.page").then(
        (m) => m.SalesPointMenuPage
      ),
  },
  {
    path: "SalesHistoryPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/sales-point-menu/sales-history/sales-history"
          ).then((m) => m.SalesHistoryPage),
      },
    ],
  },
  {
    path: "AppointmentExpenseApplicationPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/sales-point-menu/appointment-expense-application/appointment-expense-application.page"
          ).then((m) => m.AppointmentExpenseApplicationPage),
      },
    ],
  },
  {
    path: "SalesHistoryDetailPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/sales-point-menu/sales-history/sales-history-detail/sales-history-detail"
          ).then((m) => m.SalesHistoryDetailPage),
      },
    ],
  },
  {
    path: "PaymentStatementDetailPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/sales-point-menu/sales-history/payment-statement-detail/payment-statement-detail"
          ).then((m) => m.PaymentStatementDetailPage),
      },
    ],
  },
  {
    path: "TransferPriceDetailPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/sales-point-menu/sales-history/transfer-price-detail/transfer-price-detail"
          ).then((m) => m.TransferPriceDetailPage),
      },
    ],
  },
  {
    path: "EditBankPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/sales-point-menu/edit-bank/edit-bank").then(
            (m) => m.EditBankPage
          ),
      },
    ],
  },
  {
    path: "EditUserInvoiceNumberPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/sales-point-menu/edit-user-invoice-number/edit-user-invoice-number"
          ).then((m) => m.EditUserInvoiceNumberPage),
      },
    ],
  },
  {
    path: "SelectBankPage",
    loadComponent: () =>
      import(
        "./pages/mypage/sales-point-menu/edit-bank/select-bank/select-bank.page"
      ).then((m) => m.SelectBankPage),
  },
  {
    path: "TransferPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/sales-point-menu/transfer/transfer").then(
            (m) => m.TransferPage
          ),
      },
    ],
  },

  {
    path: "InterviewVisitConfirmPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/interview-visit/interview-visit-confirm/interview-visit-confirm"
          ).then((m) => m.InterviewVisitConfirmPage),
      },
    ],
  },
  {
    path: "InterviewVisitSchedulePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/interview-visit/interview-visit-schedule/interview-visit-schedule"
          ).then((m) => m.InterviewVisitSchedulePage),
      },
    ],
  },
  {
    path: "PassportPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/passport/passport").then((m) => m.PassportPage),
      },
    ],
  },
  {
    path: "TicketListPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/passport/ticket-list/ticket-list").then(
            (m) => m.TicketListPage
          ),
      },
    ],
  },
  {
    path: "GiftBoxPage",
    children: [
      // Flipper gift_box_v2 の対象ユーザーと管理者は新UI、それ以外は従来UIを表示する
      {
        path: "",
        canMatch: [matchGiftBoxV2()],
        loadComponent: () =>
          import("./pages/gift-box-v2/gift-box-v2").then(
            (m) => m.GiftBoxV2Page
          ),
      },
      {
        path: "",
        loadComponent: () =>
          import("./pages/gift-box/gift-box").then((m) => m.GiftBoxPage),
      },
    ],
  },
  {
    path: "TimelinePostDetailPage",
    loadComponent: () =>
      import(
        "./pages/timeline/timeline-post-detail/timeline-post-detail.page"
      ).then((m) => m.TimelinePostDetailPage),
  },
  {
    path: "UserProfilePage/:timestamp",
    loadComponent: () =>
      import("./pages/user-profile/user-profile.page").then(
        (m) => m.UserProfilePage
      ),
    data: { preload: true },
  },
  {
    path: "UserNoteListPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/user-note/user-note-list/page-user-note-list").then(
            (m) => m.UserNoteListPage
          ),
      },
    ],
  },
  {
    path: "EvaluationBadgeSendPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/evaluation-badge-send/evaluation-badge-send.page"
          ).then((m) => m.EvaluationBadgeSendPage),
      },
    ],
  },
  {
    path: "UserNoteSendPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/user-note/user-note-send/page-user-note-send").then(
            (m) => m.UserNoteSendPage
          ),
      },
    ],
  },
  {
    path: "UserNoteHistoryPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/user-note/user-note-history/page-user-note-history"
          ).then((m) => m.UserNoteHistoryPage),
      },
    ],
  },
  {
    path: "TagSearchPage",
    loadComponent: () =>
      import("./pages/user-profile/tag-search/tag-search.page").then(
        (m) => m.TagSearchPage
      ),
  },
  {
    path: "ShowAllUsersPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/show-all-users/show-all-users").then(
            (m) => m.ShowAllUsersPage
          ),
      },
    ],
  },
  {
    path: "FeversEditTextPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/fevers/fevers-edit-text/fevers-edit-text").then(
            (m) => m.FeversEditTextPage
          ),
      },
    ],
  },
  {
    path: "SelectFavoriteListPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/select-favorite-list/select-favorite-list").then(
            (m) => m.SelectFavoriteListPage
          ),
      },
    ],
  },
  {
    path: "SelectFavoriteListUsersPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/select-favorite-list-users/select-favorite-list-users"
          ).then((m) => m.SelectFavoriteListUsersPage),
      },
    ],
  },
  {
    path: "FavoriteListUsersPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/favorite-list-users/favorite-list-users").then(
            (m) => m.FavoriteListUsersPage
          ),
      },
    ],
  },
  {
    path: "SelectFavoritePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/chat-rooms/select-favorite/select-favorite").then(
            (m) => m.SelectFavoritePage
          ),
      },
    ],
  },
  {
    path: "FavoriteChatPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/chat-rooms/favorite-chat/favorite-chat").then(
            (m) => m.FavoriteChatPage
          ),
      },
    ],
  },
  {
    path: "GroupUsersPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/chat-rooms/chat/group-users/group-users").then(
            (m) => m.GroupUsersPage
          ),
      },
    ],
  },
  {
    path: "CastRequestConfirmPage",
    loadComponent: () =>
      import(
        "./pages/cast-request/cast-request-confirm/cast-request-confirm.page"
      ).then((m) => m.CastRequestConfirmPage),
  },
  {
    path: "CastRequestSelectDesignatableCastsStepPage",
    loadComponent: () =>
      import(
        "./pages/cast-request/cast-request-select-designatable-casts-step/cast-request-select-designatable-casts-step.page"
      ).then((m) => m.CastRequestSelectDesignatableCastsStepPage),
  },
  {
    path: "CastRequestSelectChoiceCallPage",
    loadComponent: () =>
      import(
        "./pages/cast-request/cast-request-select-choice-call/cast-request-select-choice-call.page"
      ).then((m) => m.CastRequestSelectChoiceCallPage),
  },
  {
    path: "CastRequestSelectDetailStepPage",
    loadComponent: () =>
      import(
        "./pages/cast-request/cast-request-select-detail-step/cast-request-select-detail-step.page"
      ).then((m) => m.CastRequestSelectDetailStepPage),
  },
  {
    path: "CastRequestSelectDetailByAddionalCallPage",
    loadComponent: () =>
      import(
        "./pages/cast-request/cast-request-select-detail-by-addional-call/cast-request-select-detail-by-addional-call.page"
      ).then((m) => m.CastRequestSelectDetailByAddionalCallPage),
  },
  {
    path: "CastRequestSelectDetailByLineCallPage",
    loadComponent: () =>
      import(
        "./pages/cast-request/cast-request-select-detail-by-line-call/cast-request-select-detail-by-line-call.page"
      ).then((m) => m.CastRequestSelectDetailByLineCallPage),
  },
  {
    path: "CastRequestSelectDetailStepByShopPage",
    loadComponent: () =>
      import(
        "./pages/cast-request/cast-request-select-detail-step-by-shop/cast-request-select-detail-step-by-shop.page"
      ).then((m) => m.CastRequestSelectDetailStepByShopPage),
  },
  {
    path: "CastRequestSelectSituationStepPage",
    loadComponent: () =>
      import(
        "./pages/cast-request/cast-request-select-situation-step/cast-request-select-situation-step.page"
      ).then((m) => m.CastRequestSelectSituationStepPage),
  },
  {
    path: "CastRequestWarningForFirstCallStepPage",
    loadComponent: () =>
      import(
        "./pages/cast-request/cast-request-warning-for-first-call-step/cast-request-warning-for-first-call-step.page"
      ).then((m) => m.CastRequestWarningForFirstCallStepPage),
  },
  {
    path: "SendIdentificationPostPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/send-identification-post/send-identification-post"
          ).then((m) => m.SendIdentificationPostPage),
      },
    ],
  },
  {
    path: "SendIdentificationPostSuccessPage",
    loadComponent: () =>
      import(
        "./pages/mypage/send-identification-post/send-identification-post-success/send-identification-post-success"
      ).then((m) => m.SendIdentificationPostSuccessPage),
  },
  {
    path: "SendIdentificationPostConfirmPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/mypage/send-identification-post/send-identification-post-confirm/send-identification-post-confirm"
          ).then((m) => m.SendIdentificationPostConfirmPage),
      },
    ],
  },
  {
    path: "QuickKopatoCastConfirmPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-cast-confirm/quick-kopato-cast-confirm"
          ).then((m) => m.QuickKopatoCastConfirmPage),
      },
    ],
  },
  {
    path: "QuickKopatoCastFixPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-cast-fix/quick-kopato-cast-fix"
          ).then((m) => m.QuickKopatoCastFixPage),
      },
    ],
  },
  {
    path: "QuickKopatoHomePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-home/quick-kopato-home"
          ).then((m) => m.QuickKopatoHomePage),
      },
    ],
  },
  {
    path: "QuickKopatoSelectImagePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-select-image/quick-kopato-select-image"
          ).then((m) => m.QuickKopatoSelectImagePage),
      },
    ],
  },
  {
    path: "ReadyUsedPage",
    loadComponent: () =>
      import("./pages/home/guest-home/ready-used/ready-used.page").then(
        (m) => m.ReadyUsedPage
      ),
  },
  {
    path: "AppointmentHistoryPage",
    loadComponent: () =>
      import(
        "./pages/home/guest-home/appointment-history/appointment-history-page"
      ).then((m) => m.AppointmentHistoryPage),
  },
  {
    path: "ViewMoreUserListPage",
    loadComponent: () =>
      import(
        "./pages/home/cast-home/view-more-user-list/view-more-user-list.page"
      ).then((m) => m.ViewMoreUserListPage),
  },
  {
    path: "SelectOrderLocationPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/guest-home/select-order-location/select-order-location.page"
          ).then((m) => m.SelectOrderLocationPage),
      },
    ],
  },
  {
    path: "QuickKopatoPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/home/guest-home/quick-kopato/quick-kopato").then(
            (m) => m.QuickKopatoPage
          ),
      },
    ],
  },
  {
    path: "QuickKopatoSelectMessagePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-select-message/quick-kopato-select-message"
          ).then((m) => m.QuickKopatoSelectMessagePage),
      },
    ],
  },
  {
    path: "QuickKopatoSelectPricePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-select-price/quick-kopato-select-price"
          ).then((m) => m.QuickKopatoSelectPricePage),
      },
    ],
  },
  {
    path: "QuickKopatoSelectTimePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-select-time/quick-kopato-select-time"
          ).then((m) => m.QuickKopatoSelectTimePage),
      },
    ],
  },
  {
    path: "QuickKopatoRequestLocationsWrapperPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-request-locations-wrapper/quick-kopato-request-locations-wrapper.page"
          ).then((m) => m.QuickKopatoRequestLocationsWrapperPage),
      },
    ],
  },
  {
    path: "QuickKopatoSelectLocationPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-select-location/quick-kopato-select-location"
          ).then((m) => m.QuickKopatoSelectLocationPage),
      },
    ],
  },
  {
    path: "QuickKopatoFeedbackWrapperPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/home/cast-home/quick-kopato/quick-kopato-feedback-wrapper/quick-kopato-feedback-wrapper.page"
          ).then((m) => m.QuickKopatoFeedbackWrapperPage),
      },
    ],
  },
  {
    path: "TabletHomePage",
    loadComponent: () =>
      import("./pages/tablet/tablet-home/tablet-home.page").then(
        (m) => m.TabletHomePage
      ),
  },
  {
    path: "TabletTermsPage",
    loadComponent: () =>
      import("./pages/tablet/tablet-terms/tablet-terms.page").then(
        (m) => m.TabletTermsPage
      ),
  },
  {
    path: "TabletRequestPhonePage",
    loadComponent: () =>
      import(
        "./pages/tablet/tablet-request-phone/tablet-request-phone.page"
      ).then((m) => m.TabletRequestPhonePage),
  },
  {
    path: "TabletInputCodePage",
    loadComponent: () =>
      import("./pages/tablet/tablet-input-code/tablet-input-code.page").then(
        (m) => m.TabletInputCodePage
      ),
  },
  {
    path: "TabletSelectDurationTimePage",
    loadComponent: () =>
      import(
        "./pages/tablet/tablet-select-duration-time/tablet-select-duration-time.page"
      ).then((m) => m.TabletSelectDurationTimePage),
  },
  {
    path: "TabletSelectCastPage",
    loadComponent: () =>
      import("./pages/tablet/tablet-select-cast/tablet-select-cast.page").then(
        (m) => m.TabletSelectCastPage
      ),
  },
  {
    path: "TabletSelectTagPage",
    loadComponent: () =>
      import("./pages/tablet/tablet-select-tag/tablet-select-tag.page").then(
        (m) => m.TabletSelectTagPage
      ),
  },
  {
    path: "TabletConfirmRequestPage",
    loadComponent: () =>
      import(
        "./pages/tablet/tablet-confirm-request/tablet-confirm-request.page"
      ).then((m) => m.TabletConfirmRequestPage),
  },
  {
    path: "TabletFixedRequestPage",
    loadComponent: () =>
      import(
        "./pages/tablet/tablet-fixed-request/tablet-fixed-request.page"
      ).then((m) => m.TabletFixedRequestPage),
  },
  {
    path: "TabletMatchingCastPage",
    loadComponent: () =>
      import(
        "./pages/tablet/tablet-matching-cast/tablet-matching-cast.page"
      ).then((m) => m.TabletMatchingCastPage),
  },
  {
    path: "TabletEndMeetingPage",
    loadComponent: () =>
      import("./pages/tablet/tablet-end-meeting/tablet-end-meeting.page").then(
        (m) => m.TabletEndMeetingPage
      ),
  },
  {
    path: "QuestionPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/mypage/help/question/question").then(
            (m) => m.QuestionPage
          ),
      },
    ],
  },
  {
    path: "SelectCastPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/summarize-send-gift/select-cast/select-cast").then(
            (m) => m.SelectCastPage
          ),
      },
    ],
  },
  {
    path: "SelectGiftKindPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/summarize-send-gift/select-gift-kind/select-gift-kind"
          ).then((m) => m.SelectGiftKindPage),
      },
    ],
  },
  {
    path: "ConfirmSendGiftCastPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/summarize-send-gift/confirm-send-gift-cast/confirm-send-gift-cast"
          ).then((m) => m.ConfirmSendGiftCastPage),
      },
    ],
  },
  {
    path: "SummarizeSendGiftWrapperPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/summarize-send-gift/summarize-send-gift-wrapper/summarize-send-gift-wrapper"
          ).then((m) => m.SummarizeSendGiftWrapperPage),
      },
    ],
  },
  {
    path: "GiftFeedbackMessagePage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/summarize-send-gift/gift-feedback-message/gift-feedback-message"
          ).then((m) => m.GiftFeedbackMessagePage),
      },
    ],
  },
  {
    path: "CastRequestListPage",
    loadComponent: () =>
      import(
        "./pages/shop-owner/cast-request-list/cast-request-list.page"
      ).then((m) => m.CastRequestListPage),
  },
  {
    path: "CastRequestDetailPage",
    loadComponent: () =>
      import(
        "./pages/shop-owner/cast-request-detail/cast-request-detail.page"
      ).then((m) => m.CastRequestDetailPage),
  },
  {
    path: "ViewMoreCastRequestListPage",
    loadComponent: () =>
      import(
        "./pages/home/cast-home/view-more-cast-request-list/view-more-cast-request-list.page"
      ).then((m) => m.ViewMoreCastRequestListPage),
  },
  {
    path: "PartnerHubRedirectPage",
    loadComponent: () =>
      import(
        "./pages/shop-owner/partner-hub-redirect/partner-hub-redirect.page"
      ).then((m) => m.PartnerHubRedirectPage),
  },
  {
    path: "WaitingPlaceTicketDetailPage",
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./pages/passport/waiting-place-ticket-detail/waiting-place-ticket-detail.page"
          ).then((m) => m.WaitingPlaceTicketDetailPage),
      },
    ],
  },
  {
    path: "CastAppliedPhotoUploadPage",
    loadComponent: () =>
      import(
        "./pages/cast-applied/cast-applied-photo-upload/cast-applied-photo-upload.page"
      ).then((m) => m.CastAppliedPhotoUploadPage),
  },
  {
    path: "CastLineAppliedPage",
    loadComponent: () =>
      import(
        "./pages/cast-applied/cast-line-applied/cast-line-applied.page"
      ).then((m) => m.CastLineAppliedPage),
  },
  {
    path: "CastAppliedPhotoUploadCompletePage",
    loadComponent: () =>
      import(
        "./pages/cast-applied/cast-applied-photo-upload-complete/cast-applied-photo-upload-complete.page"
      ).then((m) => m.CastAppliedPhotoUploadCompletePage),
  },
  {
    path: "CastAppliedReserveSchedulePage",
    loadComponent: () =>
      import(
        "./pages/cast-applied/cast-applied-reserve-schedule/cast-applied-reserve-schedule.page"
      ).then((m) => m.CastAppliedReserveSchedulePage),
  },
  {
    path: "CastAppliedReserveScheduleConfirmPage",
    loadComponent: () =>
      import(
        "./pages/cast-applied/cast-applied-reserve-schedule-confirm/cast-applied-reserve-schedule-confirm.page"
      ).then((m) => m.CastAppliedReserveScheduleConfirmPage),
  },
  {
    path: "CastAppliedReserveScheduleSuccessPage",
    loadComponent: () =>
      import(
        "./pages/cast-applied/cast-applied-reserve-schedule-success/cast-applied-reserve-schedule-success.page"
      ).then((m) => m.CastAppliedReserveScheduleSuccessPage),
  },
  {
    path: "CastAppliedLineIntegrationPage",
    loadComponent: () =>
      import(
        "./pages/cast-applied/cast-applied-line-integration/cast-applied-line-integration.page"
      ).then((m) => m.CastAppliedLineIntegrationPage),
  },
  {
    path: "MaintenancePage",
    loadComponent: () =>
      import("./pages/maintenance/maintenance").then((m) => m.MaintenancePage),
  },
  {
    // イベントカレンダー。ゲスト・キャストの双方から遷移するのでroleガードは付けない
    path: "EventCalendarPage",
    loadComponent: () =>
      import("./pages/event-calendar/event-calendar.page").then(
        (m) => m.EventCalendarPage
      ),
  },
];

// @NgModule({
//   imports: [
//     RouterModule.forRoot(routes, {
//       preloadingStrategy: PreloadAllModules,
//       initialNavigation: "disabled",
//       useHash: true,
//       enableTracing: true,
//     }),
//   ],
//   exports: [RouterModule],
// })
// export class AppRoutingModule {}
